import ALL_GROUP_ALERTS from "./query.gql";

export interface AlertData {
  id: string;
  lock: {
    id: string;
  };
  building: {
    id: string;
    name: string;
    token: string;
  };
  room: {
    id: string;
    name: string;
    mode: string;
    group: {
      id: string;
    };
  };
  type: number;
  isResolved: boolean;
  createdAt: number;
}

export interface AllAlertData {
  alertFeed: {
    alerts: AlertData[];
  };
}

export { ALL_GROUP_ALERTS };
